export enum LoginStatesEnum {
  Login,
  ForgotPw,
  SetupMFA,
}

// 6 months in hours
export const COOKIE_EXPIRY = 4380;
